module.exports = __webpack_public_path__ + "img/formation_bg.a449407a.svg";